export default __webpack_public_path__ + "static/media/petgramImg_4.dfc8b719.webp";